import { RouteDetailsList } from "models/routeDetails/RouteDetailsList";
import { RouteAggregationsList } from "models/routeAggregations/RouteAggregationsList";
import { RouteDetailsRequestModel } from "api/lokiRequestModels/route/RouteDetailsRequestModel";
import { RouteAggregationsRequestModel } from "api/lokiRequestModels/route/RouteAggregationsRequestModel";
import { RouteTempExcursionAggregationsRequestModel } from "api/lokiRequestModels/route/RouteTempExcursionAggregationsRequestModel";
import { config } from "api/apiRoutes";
import { LaneExcursionsList } from "models/laneExcursion/LaneExcursionList";
import { lokiAxios } from "api/serviceConfig";

export class RouteService {
    // 4
    async listRouteDetails(data: RouteDetailsRequestModel) {
        return await lokiAxios.get<RouteDetailsList>(
            config.laneRoutesUrl(data.laneId),
            {
                params: {
                    startTime: data.startTime,
                    endTime: data.endTime,
                    customerId: data.customerId,
                    lsp: data.lsp,
                    productType: data.productType,
                    riskLevel: data.riskLevel, // change
                    transportationModes: data.transportationModes, // change
                    packagingType: data.packagingType,
                    nextToken: data.nextToken,
                    sort: data.sort,
                    direction: data.direction,
                },
            }
        );
    }

    // 5
    async getRouteAggregations(data: RouteAggregationsRequestModel) {
        return await lokiAxios.get<RouteAggregationsList>(
            config.routeAggregationsUrl(data.laneId),
            {
                params: {
                    startTime: data.startTime,
                    endTime: data.endTime,
                    customerId: data.customerId,
                    lsp: data.lsp,
                    productType: data.productType,
                    riskLevel: data.riskLevel, // change
                    transportationModes: data.transportationModes, // change
                    packagingType: data.packagingType,
                },
            }
        );
    }

    // 6
    async getRouteTempExcursionAggregations(
        data: RouteTempExcursionAggregationsRequestModel
    ) {
        return await lokiAxios.get<LaneExcursionsList>(
            config.routeTempExcursionAggregationsUrl(data.laneId),
            {
                params: {
                    startTime: data.startTime,
                    endTime: data.endTime,
                    customerId: data.customerId,
                    lsp: data.lsp,
                    productType: data.productType,
                    riskLevel: data.riskLevel, // change
                    transportationModes: data.transportationModes, // change
                    packagingType: data.packagingType,
                },
            }
        );
    }
}
